module.exports = __webpack_public_path__ + "static/media/settings.b3d8f398.png";